import React, { useEffect, useState } from "react";
import Banner from "./banner-section";
import { Helmet } from "react-helmet";
import Footer from "./footer";
import Navbar from "./navbar";
import Loading from "./loading";

export default function Everything_You_Need_To_Know() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Mosaic Tiles: A Complete Guide</title>
        <meta
          name="description"
          content="A mosaic tile can enhance the aesthetics of your home in many ways, from wall cladding to swimming pool flooring. Learn everything about beautiful mosaic tiles and why homeowners want them in their home decor. "
        />
      </Helmet>
      {loading ? (
        <Loading />
      ) : (
        <>
          <Navbar modalBg="modalbg" />
          <main id="blog-inside">
            <Banner
              data="Mosaic Tiles: A Complete Guide"
              image="preview/mosaic.jpg"
            />
            <section className="section-2 padding-top">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-xl-7">
                    {/* <h2>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perspiciatis, molestiae.</h2> */}
                    <p className="mt-0">
                      Who doesn’t love beautifully sophisticated designs in
                      their home? Mosaic tile has been popular for thousands of
                      years for its dazzling designs and high-end quality.
                    </p>
                    <p size="18px">
                      Whether you’re looking for a style that will help make the
                      room look cohesive or want to make your space stand out
                      above the rest, installing mosaic tiles is the right
                      choice to put an exclamation point on your decor plans.
                    </p>
                    <p size="18px">
                      Learn more about mosaic tiles from Ignite to find
                      the right style for your home.
                    </p>

                    <h2 id="What-Are-Mosaic-Tiles?">What Are Mosaic Tiles?</h2>
                    <p size="18px">
                      Mosaics have a long history; from the complicated mosaic
                      design of ancient greek to old-fashioned mosaics in your
                      elder's home, mosaics have continued to be favoured over
                      the centuries!
                    </p>
                    <p size="18px">
                      In ancient times, mosaics were used as a creative way to
                      elaborate art or patterns. “Mosaic” mainly means “a design
                      composed of many small pieces of tiles.”
                    </p>
                    <p size="18px">
                      They come in various designs, patterns, colours and
                      textures, making them more accessible material for your
                      decor.
                    </p>
                    <p size="18px">
                      You can set the tiles in any design you want, in a
                      repeating pattern or randomly, and they can be laid on
                      mesh sheets for easier installation.
                    </p>

                    <h2 id="Different-Types-Of-Material-Use-For-Mosaic-Tiles">
                      Different Types Of Material Use For Mosaic Tiles
                    </h2>
                    <p size="18px">
                      You might be wondering, “what type of material is used to
                      create a beautiful mosaic design?”
                    </p>
                    <p size="18px">
                      Initially, the pattern or picture is made from small
                      hand-cut pieces of stone, glass or porcelain tile. From an
                      interior design standpoint, choosing the best mosaic tile
                      material for your home takes time and effort.
                    </p>
                    <p size="18px">
                      So, let’s get into the materials used for the mosaic
                      design you can choose for your home!
                    </p>

                    <ol>
                      <li id="Vitrified-Mosaic-Tiles">
                        <h3>1. Vitrified Mosaic Tiles</h3>
                        <p size="18px">
                          Vitrified tiles are the strongest and toughest
                          materials. They have been used for interior decor for
                          years in our Indian culture and worldwide.
                        </p>
                        <p size="18px">
                          Mosaics from these materials don't compromise their
                          strength and structure due to extensive wear and tear.
                          In fact, consider choosing these mosaics in
                          high-traffic areas for their durability and resistance
                          to break or chip.
                        </p>
                        <p size="18px">
                          With these natural stone mosaic tiles, you can bring a
                          sense of earthiness to your home. Add warmness with
                          multi-coloured pebbles in your restrooms or a polished
                          marble stone on your living room wall.
                        </p>
                      </li>
                      <li id="Ceramic-&-Porcelain-Mosaic-Tiles">
                        <h3>2. Ceramic & Porcelain Mosaic Tiles</h3>
                        <p size="18px">
                          Ceramic and porcelain are the two most common
                          materials used in mosaic tiles for the home interior
                          to create a unique personality.
                        </p>
                        <p size="18px">
                          These are clay-based mosaics that are durable and
                          available in a wide variety of colours and finishes to
                          achieve any look whether it's a retro feel or the
                          latest style.
                        </p>
                        <p size="18px">
                          If you talk about their strength and durability, it’s
                          undoubtedly trustworthy as they are extremely water
                          resistant. You can consider them used in bathrooms,
                          kitchen countertops or wet locations.
                        </p>
                        <p size="18px">
                          Choosing a particular design or pattern with ceramic
                          and porcelain mosaic tiles is easy, with endless
                          design options.
                        </p>
                      </li>
                      <li id="Metal-Mosaic-Tiles">
                        <h3>3. Metal Mosaic Tiles</h3>
                        <p size="18px">
                          Want an industrial and sophisticated appearance for
                          your workspace? You should go for metal mosaic tiles!
                        </p>
                        <p size="18px">
                          Mosaic tiles made from metal have a modern appeal and
                          are available in a variety of patterns that create
                          enticing designs to look at. The shiny surface of this
                          tile is elegant and spreads natural light throughout
                          the room, making it the best choice for walls.
                        </p>
                        <p size="18px">
                          These mosaics need low maintenance, moisture and stain
                          resistance, which makes them the ideal choice for
                          heavy-traffic areas like kitchens, living rooms, or
                          bathrooms.
                        </p>
                      </li>
                      <li id="Glass-Mosaic-Tiles">
                        <h3>4. Glass Mosaic Tiles</h3>
                        <p size="18px">
                          Glass mosaic tile material is the most popular
                          decorative surface in the world. Even the ancient
                          Mughal empire took advantage of the beauty of this
                          material.
                        </p>
                        <p size="18px">
                          There are limitless options when choosing a glass
                          mosaic tile pattern with a wide range of colours and
                          styles. It's an excellent choice for backsplashes and
                          wall decoration.
                        </p>
                        <p size="18px">
                          Glass mosaics are known for their stain & moisture
                          resistance and durability; you can rest assured for
                          years.
                        </p>
                      </li>
                      <li id="Hot-Melt-Glass-Mosaic">
                        <h3>5. Hot Melt Glass Mosaic</h3>
                        <p>
                          Hot melt glass mosaics are dazzling and elegant style
                          material. Their combination of colours and crafts
                          allows us to let our imaginations run wild.
                        </p>
                        <p size="18px">
                          It has not taken long for these mosaics to become
                          popular in interior decor. They‘re like adding a
                          finishing touch to the decoration. Hot melt glass
                          mosaic is excellent for wall decoration in homes,
                          hotels, restaurants, theatres, and other prominent
                          entertainment places.
                        </p>
                      </li>
                    </ol>
                    <h2 className="text-center" id="Merits-&-Demerits-Of-Mosaic-Tiles">
                      Merits & Demerits Of Mosaic Tiles
                    </h2>
                    <div className="pros-cons">
                      <div className="pros-container">
                        <h2 className="heading">Pros</h2>
                        <ul className="pros">
                          <li>Creativity</li>
                          <li>Design versatility</li>
                          <li>Durability</li>
                          <li>Extremely water resistance</li>
                          <li>Resistant to break or chipped</li>
                        </ul>
                      </div>

                      <div className="cons-container">
                        <h2 className="heading">Cons</h2>
                        <ul className="cons">
                          <li>Tricky to install</li>
                          <li>Cleaning grout</li>
                          <li>Slippery </li>
                        </ul>
                      </div>
                    </div>
                    <h3>Note:</h3>
                    <p size="18px">
                      Mosaic tiles of ceramic or porcelain offer low-maintenance
                      and healthy benefits options.
                    </p>
                    <h2 id="Ideal-Application">Ideal Application</h2>
                    <p size="18px">
                      Mosaic tiles for floors make a room. But it doesn't stop
                      at flooring! It became famous for backsplashes, walls, and
                      showers.
                    </p>
                    <p size="18px">
                      The installation process can be a significant investment,
                      but the unique look and texture make them more worthy!
                      Here are a few great places to consider installing your
                      first mosaic tile art.
                    </p>
                    <ol>
                      <li id="Floors">
                        <h3>1. Floors</h3>
                        <p size="18px">
                          Create an elegant look in your bathroom space using
                          mosaic tiles on the floor. They have durable structure
                          and water resistance, making them ideal for floors.
                        </p>
                        <p size="18px">
                          The plus point of using mosaics as flooring options is
                          that they do not break or chip easily through wear and
                          tear.
                        </p>
                      </li>
                      <li id="Walls">
                        <h3>2. Walls</h3>
                        <p size="18px">
                          If you want a sophisticated and seamless look in your
                          space, extend your mosaic floor tile up to the wall.
                          This is a great way to create uniqueness in the space.
                        </p>
                      </li>
                      <li id="Shower">
                        <h3>3. Shower</h3>
                        <p size="18px">
                          Mosaic tiles are ideal for wet areas; you can consider
                          installing them in the shower. The resistance against
                          moisture makes it stay for an extended period and
                          provides the next level of relaxation while showering.
                        </p>
                      </li>
                      <li id="Backsplashes">
                        <h3>4. Backsplashes</h3>
                        <p size="18px">
                          As mentioned above, exceptional durability, moisture
                          and stain resistance make them perfect for kitchen and
                          bathroom backsplashes. They can effortlessly last in
                          moist places.
                        </p>
                      </li>
                    </ol>
                    <h2 id="Tips-To-Care-&-Maintain-Mosaic-Tiles">
                      Tips To Care & Maintain Mosaic Tiles
                    </h2>
                    <ul>
                      <li>
                        <p size="18px">
                          {" "}
                          Clean the spillage on the surface immediately before
                          it stains the tile (if it’s stone mosaic tile).
                        </p>
                      </li>
                      <li>
                        <p size="18px">
                          {" "}
                          Avoid dragging bulky furniture to secure it from
                          damage and scratches.
                        </p>
                      </li>
                      <li>
                        <p> Vacuum your space before mopping. </p>
                      </li>
                      <li>
                        <p size="18px">
                          {" "}
                          Mop the space occasionally to maintain its shine and
                          beautiful look.
                        </p>
                      </li>
                      <li>
                        <p size="18px"> Avoid using harsh chemicals and scrubbing. </p>
                      </li>
                    </ul>
                    <h2 id="Bottom-Line">Bottom Line</h2>
                    <p>
                      We hope the above information about mosaic tiles help to
                      understand what they are, the different types of material,
                      benefits and drawbacks, where you can use and some tips on
                      how to care.
                    </p>
                    <h3 className="text-center">
                      Add A Style To Your Home With Ignite Mosaic
                    </h3>
                  </div>
                  <div className="col-xl-4 order-first order-xl-last mb-xl-0 mb-5 ms-xl-4">
                    <div className="table-of-content">
                      <h3>Table Of Content</h3>
                      <ul>
                        <li>
                          <a href="#What-Are-Mosaic-Tiles?">
                            What Are Mosaic Tiles?
                          </a>
                        </li>
                        <li>
                          <a href="#Different-Types-Of-Material-Use-For-Mosaic-Tiles">
                            Different Types Of Material Use For Mosaic Tiles
                          </a>
                        </li>
                        <ul>
                          <li>
                            <a href="#Vitrified-Mosaic-Tiles">
                              Vitrified Mosaic Tiles
                            </a>
                          </li>
                          <li>
                            <a href="#Ceramic-&-Porcelain-Mosaic-Tiles">
                              Ceramic & Porcelain Mosaic Tiles
                            </a>
                          </li>
                          <li>
                            <a href="#Metal-Mosaic-Tiles">Metal Mosaic Tiles</a>
                          </li>
                          <li>
                            <a href="#Glass-Mosaic-Tiles">Glass Mosaic Tiles</a>
                          </li>
                          <li>
                            <a href="#Hot-Melt-Glass-Mosaic">
                              Hot Melt Glass Mosaic
                            </a>
                          </li>
                        </ul>
                        <li>
                          <a href="#Merits-&-Demerits-Of-Mosaic-Tiles">
                            Merits & Demerits Of Mosaic Tiles
                          </a>
                        </li>
                        <li>
                          <a href="#Ideal-Application">Ideal Application</a>
                        </li>
                        <ul>
                          <li>
                            <a href="#Floors">Floors</a>
                          </li>
                          <li>
                            <a href="#Walls">Walls</a>
                          </li>
                          <li>
                            <a href="#Shower">Shower</a>
                          </li>
                          <li>
                            <a href="#Backsplashes">Backsplashes</a>
                          </li>
                        </ul>
                        <li>
                          <a href="#Tips-To-Care-&-Maintain-Mosaic-Tiles">
                            Tips To Care & Maintain Mosaic Tiles
                          </a>
                        </li>
                        <li>
                          <a href="#Bottom-Line">Bottom Line</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
        </>
      )}
    </>
  );
}
